'use client';
import React from 'react';
import { Button } from '@benzinga/core-ui';

interface Props {
  insiderName: string;
}

export const InsiderTradesProCTA: React.FC<Props> = ({ insiderName }) => {
  const url = `https://www.benzinga.com/pro/register/?utm_campaign=real-time-alerts&utm_adType=networth-page&ad&utm_ad=insider-trades-cta-${insiderName.toLowerCase().replaceAll(' ', '-')}`;
  const [showBanner, setShowBanner] = React.useState(true);

  React.useEffect(() => {
    try {
      const userPermissions = localStorage.getItem('permissions');
      const proPermission = JSON.parse(userPermissions || '[]').find(
        perm => perm.action === 'bzpro/dashboard/open' && perm.effect === 'allow',
      );
      if (proPermission) {
        setShowBanner(false);
      }
    } catch (error) {
      console.log('Error checking user permissions:', error);
    }
  }, []);

  if (!showBanner) {
    return null;
  }

  return (
    <div className="@container px-4">
      <a
        className="relative block w-full min-h-12 overflow-hidden rounded-lg no-underline bg-[#1D222C]
      bg-[url('/next-assets/images/watchlist-widget-background.png')]
      @[720px]:bg-[url('/next-assets/images/watchlist-prompt-banner-background.png')]
      bg-bottom @[720px]:bg-right bg-no-repeat bg-cover @[720px]:bg-contain"
        href={url}
        rel="noreferrer"
        target="_blank"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#1D222C] from-50% to-transparent" />
        <div className="relative flex flex-col @[720px]:flex-row items-start @[720px]:items-center gap-3 w-full px-4 py-3">
          <div className="px-1.5 py-[0.05rem] bg-blue-50 backdrop-blur-sm rounded">
            <span className="text-blue-500 text-sm font-bold tracking-wide">FREE</span>
          </div>

          <div className="flex flex-col @[720px]:flex-row @[720px]:items-center gap-2 min-w-0">
            <span className="text-white text-lg @[720px]:text-sm font-bold tracking-wide uppercase">
              Get Real-Time Insider Trade Alerts
            </span>
            <span className="text-gray-400 text-sm @[720px]:text-xs truncate @[720px]:inline @[720px]:ml-2">
              Be the first to know when {insiderName} or other insiders make moves. Benzinga Pro delivers instant
              alerts.{' '}
            </span>
          </div>
          <Button
            as="span"
            className="uppercase w-full h-[40px] @[720px]:w-auto @[720px]:h-auto"
            variant="flat-blue"
          >
            Start Free Trial
          </Button>
        </div>
      </a>
    </div>
  );
};
